export const toParams = (querystring: string) => {
    // Make sure there is no ? at the beginning of the string
    if (querystring[0] === '?') {
        querystring = querystring.substring(1);
    }

    const params = {};
    const qsSplit = querystring.split('&');
    qsSplit.forEach(qs => {
        const keyValue = qs.split('=');
        params[keyValue[0]] = keyValue[1];
    });

    return params;
};
